import PropTypes from 'prop-types';
import { componentMapping } from '../mapping';

const SingleColumn = ({ widgets, espotData, getEspotContent }) => {
  const slot1Widgets = widgets.filter(widget => widget.slot === '1');
  return slot1Widgets.map(widget => {
    const {
      widgetDefinitionIdentifier,
      widgetId,
      widgetProps = {},
      name
    } = widget;
    const Comp = componentMapping[widgetDefinitionIdentifier];

    // TODO: Error Handling
    return !!Comp ? (
      <div key={widgetId} data-widgetname_ga={name}>
        <Comp
          widgetProps={widgetProps}
          espotData={espotData}
          getEspotContent={getEspotContent}
          widgetIdentifier={name}
          widgetId={widgetId}
        />
      </div>
    ) : (
      <div
        key={widgetId}
      >{`Component with id ${widgetDefinitionIdentifier} does not exist.`}</div>
    );
  });
};

SingleColumn.propTypes = {
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      slot: PropTypes.string,
      widgetDefinitionIdentifier: PropTypes.string.isRequired,
      widgetSequence: PropTypes.number.isRequired,
      widgetProps: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      )
    })
  ).isRequired,
  espotData: PropTypes.objectOf(PropTypes.string)
};

export default SingleColumn;
